const ASSUMED_MAINTENANCE_RATE_PERCENT = 2.5;
const SAFETY_FACTOR = 0.9;
function liquidationMovePercent(leverage) {
    if (!Number.isFinite(leverage) || leverage < 1)
        return null;
    const initialMarginPercent = 100 / leverage;
    const maintenancePercent = Math.min(ASSUMED_MAINTENANCE_RATE_PERCENT, initialMarginPercent / 2);
    return initialMarginPercent - maintenancePercent;
}
export function maxStopLossPercentForLeverage(leverage) {
    const liqMove = liquidationMovePercent(leverage);
    if (liqMove == null)
        return null;
    return Math.floor(liqMove * SAFETY_FACTOR * 10) / 10;
}
export function estimatedLiquidationPrice(entryPrice, leverage, positionType) {
    const liqMove = liquidationMovePercent(leverage);
    if (liqMove == null || !(entryPrice > 0))
        return null;
    return positionType === "LONG"
        ? entryPrice * (1 - liqMove / 100)
        : entryPrice * (1 + liqMove / 100);
}
export function tpSlTriggerPrice(entryPrice, percent, positionType, variant) {
    if (!(entryPrice > 0) || !(percent > 0))
        return null;
    const up = (positionType === "LONG") === (variant === "tp");
    return entryPrice * (up ? 1 + percent / 100 : 1 - percent / 100);
}
export function stopLossPastLiquidationError(stopLossPercent, leverage) {
    if (stopLossPercent == null || !(stopLossPercent > 0) || leverage == null) {
        return null;
    }
    const max = maxStopLossPercentForLeverage(leverage);
    if (max == null || stopLossPercent <= max)
        return null;
    return `Stop loss ${stopLossPercent}% is past the liquidation price at ${leverage}x, so it would never trigger. Use ${max}% or less, or lower the leverage.`;
}
export function protectionPriceError(args) {
    const { kind, price, positionType, markPrice } = args;
    if (!Number.isFinite(price) || price <= 0) {
        return kind === "takeProfit"
            ? "Enter a take profit price above 0."
            : "Enter a stop loss price above 0.";
    }
    const isLong = positionType === "LONG";
    if (markPrice > 0) {
        if (kind === "takeProfit") {
            if (isLong && price <= markPrice) {
                return "Take profit must be above the current price for a long.";
            }
            if (!isLong && price >= markPrice) {
                return "Take profit must be below the current price for a short.";
            }
        }
        else {
            if (isLong && price >= markPrice) {
                return "Stop loss must be below the current price for a long.";
            }
            if (!isLong && price <= markPrice) {
                return "Stop loss must be above the current price for a short.";
            }
        }
    }
    if (kind === "stopLoss") {
        const liquidation = args.liquidationPrice && args.liquidationPrice > 0
            ? args.liquidationPrice
            : args.entryPrice && args.leverage
                ? estimatedLiquidationPrice(args.entryPrice, args.leverage, positionType)
                : null;
        if (liquidation) {
            const pastLiquidation = isLong
                ? price <= liquidation
                : price >= liquidation;
            if (pastLiquidation) {
                return `Stop loss is past the liquidation price (${formatLimitPrice(liquidation)}), so it would never trigger.`;
            }
        }
    }
    return null;
}
function formatLimitPrice(price) {
    return Number(price.toPrecision(5)).toString();
}
//# sourceMappingURL=stop-loss-limit.js.map